import { defineStore } from 'pinia';

export const useFocusManager = defineStore('focusManager', {
  state: () => ({
    focusAreas: [] as string[], // List of registered focus areas
    currentFocusIndex: -1, // Currently focused area
  }),
  actions: {
    isInputFocused(): boolean {
      const activeElement = document.activeElement;
      return !!(activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName));
    },
    registerFocusArea(areaId: string): void {
      if (!this.focusAreas.includes(areaId)) {
        this.focusAreas.push(areaId);
      }
    },
    unregisterFocusArea(areaId: string): void {
      this.focusAreas = this.focusAreas.filter((id) => id !== areaId);
    },
    focusNextArea(event?: any): void {
      if (this.focusAreas.length === 0 || this.isInputFocused()) return;
      event?.preventDefault();
      this.currentFocusIndex = (this.currentFocusIndex + 1) % this.focusAreas.length;
      const areaId = this.focusAreas[this.currentFocusIndex];
      if (areaId) this.setFocus(areaId);
    },
    focusPreviousArea(event?: any): void {
      if (this.focusAreas.length === 0 || this.isInputFocused()) return;
      event?.preventDefault();
      this.currentFocusIndex =
        (this.currentFocusIndex - 1 + this.focusAreas.length) % this.focusAreas.length;
      const areaId = this.focusAreas[this.currentFocusIndex];
      if (areaId) this.setFocus(areaId);
    },
    setFocus(areaId: string): void {
      const element = document.querySelector<HTMLElement>(`[data-focus-area="${areaId}"]`);
      element?.focus();
    },
    updateFocusByElement(element: HTMLElement): void {
      const areaId = element.getAttribute('data-focus-area');
      if (areaId && this.focusAreas.includes(areaId)) {
        this.currentFocusIndex = this.focusAreas.indexOf(areaId);
        this.setFocus(areaId);
      }
    },
    updateFocusIndexByID(areaId: string): void {
      if (areaId && this.focusAreas.includes(areaId)) {
        this.currentFocusIndex = this.focusAreas.indexOf(areaId);
      }
    },
  },
});
